<template>
  <div class="app-page-container">
    <div class="app-body">
      <h1 class="title">{{ $t("delOperation.title") }}</h1>
      <p class="desc">
        {{ $t("delOperation.desc") }}
      </p>
      <div class="form-check-label" @click="toggleClick">
        <span
          class="check-box"
          :class="{ active: checkFlag ,shake:shakeFlag}"
          ><i class="fa fa-check" v-show="checkFlag"></i
        ></span>
        <span class="check-label">  {{ $store.state.gameName }}</span>
      
      </div>
      
      <!-- 人机校验 -->
      <div
        id="g-recaptcha"
        class="g-recaptcha"
        data-sitekey="6Le_suQZAAAAADBbYsFKsD_DaiRrzfhVqzypfcet"
      ></div>
      <p class="reason-label">{{ $t("delOperation.reason") }}</p>
     
      <button class="game-button border reason" @click="selReason">
       

        <span>  {{ deleteReasonShow }}</span>
        <span class="arrow"></span>
      </button>
      <mt-actionsheet
        :actions="actions"
        :cancelText="$t('common.cancel')"
        v-model="sheetVisible"
      >
      </mt-actionsheet>
      <button
        class="game-button primary"
        @click="deleteOpe"
      >
        {{ $t("delOperation.delBtn") }}
      </button>
      <button class="game-button default" @click="backToHome">
        {{ $t("common.cancel") }}
      </button>
    </div>
    <description></description>
    <footerBar :activeIndex="1" @showLanguage="showLanguage"></footerBar>
  </div>
</template>
<script>
var reCaptchaResponse = "";
import { MessageBox, Toast } from "mint-ui";
import footerBar from "../components/common/footer";
import description from "../components/common/description";
export default {
  data() {
    return {
      checkFlag: false,
      shakeFlag: false,
      actions: [],
      sheetVisible: false,
      deleteReason: this.$t("toast.selectReason"),
      deleteReasonShow: this.$t("toast.selectReason"),
    };
  },
  components: {
    footerBar,
    description,
  },

  mounted() {
    setTimeout(() => {
      this.test();
    }, 400);
  },
  methods: {
      showLanguage(){
      this.$emit('showLanguage')
    },
    test() {
      if (this.$store.state.autoLogined) {
        return;
      }
      window.grecaptcha.render("g-recaptcha", {
        sitekey: "6Le_suQZAAAAADBbYsFKsD_DaiRrzfhVqzypfcet",
        callback: function (response) {
          reCaptchaResponse = response;
        },
      });
    },
    selReason() {
      const _this = this;
      _this.sheetVisible = true;
      // uno
      _this.actions =
        _this.$store.state.gameName.indexOf("UNO") > -1
          ? [
              {
                name: this.$t("delOperation.uno-1"),
                value: "Create Multiple Accounts Accidently",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.uno-2"),
                value: "Unable to Unbind Third-Party Accounts",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.uno-3"),
                value: "Unfair Game",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.uno-4"),
                value: "No Longer Play the Game",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.uno-5"),
                value: "Too Many Bugs/Issues",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.uno-6"),
                value: "Harassment/Abuse Concerns",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.uno-7"),
                value: "Disagree with Terms/Privacy Policy",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.uno-8"),
                value: "Other",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
            ] //PHASE 10
          : [
              {
                name: this.$t("delOperation.p10-1"),
                value: "Hard to Win/Unfair Game",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.p10-2"),
                value: "Too much ads",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.p10-3"),
                value: "No more new levels",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.p10-4"),
                value: "Long Time Recovery",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.p10-5"),
                value: "No Longer Play the Game",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.p10-6"),
                value: "Too Many Bugs/Issues",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.p10-7"),
                value: "Harassment/Abuse Concerns",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.p10-8"),
                value: "Disagree with Terms/Privacy Policy",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
              {
                name: this.$t("delOperation.p10-9"),
                value: "Other",
                method: (rea) => {
                  _this.checkReason(rea);
                },
              },
            ];
    },
    checkReason(rea) {
      const _this = this;
      _this.deleteReason = rea.value;
      _this.deleteReasonShow = rea.name;
      _this.sheetVisible = false;
    },
    toggleClick() {
      this.checkFlag = !this.checkFlag;
    },
    onSubmit() {
      document.getElementById("demo-form").submit();
    },
    backToHome() {
      this.$router.push("./Home");
    },
    deleteOpe() {
            const _this = this;
      if(!this.checkFlag){
        this.shakeFlag =true
            Toast({
              message: this.$t("toast.checkTip2"),  // 请勾选
            });

            setTimeout(() => {
              this.shakeFlag =false
            }, 1000);
            return


      }else{

    
      if (_this.$store.state.taskExist) {
        this.$router.push({ name: "DeletePend" });
          return false;
      } else if (
        _this.$store.state.pendFlag ||
        this.$store.state.requestDataState === 1
      ) {
        this.$router.push({ name: "forbiddenRequest" });
          return false;
      }
      if (_this.deleteReason === "Select a reason") {
        Toast({
          message: this.$t("toast.selectReason"),
        });
        return false;
      }
      //  人机校验
      if (!reCaptchaResponse.length && !_this.$store.state.autoLogined) {
        Toast({
          message: this.$t("toast.follow"),
        });
        return false;
      }
      MessageBox.confirm(this.$t("toast.confirmTitle"), {
        confirmButtonText: this.$t("toast.confirm"),
        cancelButtonText: this.$t("common.cancel"),
      }).then(() => {
        this.$axios({
          method: "post",
          url: "/privacy/del/account",
          data: {
            pinToken: _this.$cookie.get("token"),
            desc: _this.deleteReason,
            grecaptcha: reCaptchaResponse,
            ua:navigator.userAgent || ''
          },
        })
          .then((res) => {
            if (res.status === 200 && res.data.c === 0) {
              reCaptchaResponse = "";
              this.$router.push("/DeletePend");
            } else {
              Toast({
                message: res.data.d,
              });
            }
          })
          .catch(() => {
            Toast({
              message: "error",
            });
          });
      });
    }  }
  },
};
</script>
<style lang="less" scoped>

.title {
         padding-top: 0.5rem;
    font-size: 0.53rem;
    font-weight: bold;
    margin-bottom: 0.42rem;
}
.white {
  background: transparent;
}
.desc {
  margin-bottom: .42rem;
  font-size: .34rem;
 text-align: left;
}

.reason-label{
  font-size: 0.32rem;
   text-align: left;
   margin-bottom: 0.2rem;
}
.reason{
  display: flex;
   justify-content: space-between;
  align-items: center;
  padding: 0.16rem 0.42rem;
  height: unset;
    .arrow {
      background: url("../assets/arrow.png") no-repeat center center;
      background-size: contain;
      width: 0.26rem;
      height: 0.26rem;
      display: inline-block;
      margin-left: 0.1rem;
    }
}
.form-check-label {
  //  height: 120px;
  height: 25px;
  margin-bottom: .5rem;
  position: relative;
  font-size: 0.56rem;
  display: flex;
  justify-content: start;
  align-items: center;
      gap: 0.32rem;
      .check-label{
        flex: 1;
        font-weight: 700;
        color: #000000 ;
        font-size: 0.37rem;

      }
  .check-box {
    // position: absolute;
    display: inline-block;
     width: .53rem;
    height: .53rem;
    // left: 0.5rem;
    line-height: .53rem;
    border-radius: 0.15rem;
    color: #ffffff;
    font-size: .42rem;
    text-align: center;
    background-color: transparent;
    background-image: none;
    border: 1px solid #666666 ;
    &.active {
     width: .53rem;
    height: .53rem;
       background: rgb(16,142,233);
      border: 1px solid rgb(16,142,233);
    }
  }
}

@media screen and (orientation: landscape) {
  .app-page-container{
      overflow-y: auto !important;
      padding-bottom: 3rem;
      display: block;
  }
    .app-body {
        width: 60%;
        margin: 0 auto;
        overflow-y: unset;
        height: unset;
        padding-bottom: 0;
        overflow: hidden;
    }
  .title {
         padding-top:0 !important;
  
}

}
</style>